import React from "react";
import Teams from "../../../../api/Teams";
import { numericSuffix } from "../../../../services/utils";

function TopTeams({ teams = [], top_performers = {} }) {
  const colors = Teams.competitiveColors();
  let top_teams = [];
  if ("teams" in top_performers) {
    top_teams = top_performers.teams;
  }

  if (top_teams.length > 0) {
    top_teams.sort((a, b) => {
      return b.weighted_value - a.weighted_value;
    });
  }

  if (top_teams.length > 7) {
    top_teams = top_teams.slice(0, 7);
  }

  return (
    <div className="col-md-4 col-xs-12">
      <div className="bg-white p-30 mh-230">
        <h5 className="text-center">TOP TEAMS</h5>
        <div className="panel-dashboard-white mt-30 text-center">
          <div className="table-responsive">
            <table className="table table-top-list">
              <tbody>
                {top_teams.map((top_team, num) => {
                  const { team_id, team__name } = top_team;
                  let index = 0;
                  Object.keys(teams).forEach((id, i) => {
                    let idNum = parseInt(id, 10);
                    if (isNaN(idNum)) {
                      idNum = 0;
                    }
                    if (team_id === idNum) {
                      index = i;
                    }
                  });
                  const squareStyle = {
                    display: "inline-block",
                    width: 15,
                    height: 15,
                    backgroundColor: colors[index % colors.length]
                  };

                  return (
                    <tr className="text-center" key={team_id}>
                      <td className="short-column">{numericSuffix(num + 1)}</td>
                      <td className="short-column">
                        <span style={squareStyle} />
                      </td>
                      <td>{team__name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopTeams;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/top-teams.js